import { versionWithBuild as version } from './version';

export const environment = {
  production: true,
  endpoint: `https://auditbackendpoc.stpehs.com/api/`,
  authURL: `https://auth.stpehs.com/audithub_poc/login`,
  PROTOCOL_VIRTUAL_DIRECTORY: "publications/",
  DOMAIN: `.stpehs.com`,
  StpDomain: `https://www.stpub.com`,
  AudithubDomain: `https://audithub-poc.stpehs.com/`,
  RegHubDomain: "https://reghub-poc.stpehs.com",
  secretKey: `093425346907875356244547`,
  version,
  profileApiUrl: "https://stp-api.azurewebsites.net/api/",
  profileApiKey: "bac1fedabe9649e88285218640ce0504",
  cookieIdleMultiTab: "activeAt",
  token: "STPHUB_TOKEN",
  companyName: "COMPANY_Name",
};
